import * as yup from "yup";

const validation = (t) => {
  return yup.object().shape({});
};

export default validation;
